import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiButtonGroup = { defaultProps: { disableRipple: true } } satisfies Components<Theme>["MuiButtonGroup"];
